import { useQuery } from "@tanstack/react-query";
import { AXIOS_RESERVATION } from "../utils/axios-interceptors";
import { IUseGetComponentsListQueryResponse } from "../utils/types";

const useGetComponentsList = (viewType: string, isOpen: boolean): IUseGetComponentsListQueryResponse => {
  return useQuery({
    queryKey: ["components-list", viewType, isOpen],
    queryFn: async () => {
      const response = await AXIOS_RESERVATION.get("/v1/get-components-list", {
        params: { viewType },
      });
      return response.data;
    },
  });
};

export default useGetComponentsList;